﻿import React from "react";
import NavLink from "./NavLink"

interface NavGroupProps {
    GroupName: string;
    NavLinks: NavLink[];
}

const NavGroup = (props:NavGroupProps) => {

    return (
        <div className="submenu_group">
            {props.GroupName != null && props.GroupName.length > 0 ? 
                <h3>{props.GroupName}</h3> : <h3 className={"empty-heading"}>&nbsp;</h3> }
            <ul>
                {props.NavLinks
                    .sort((a, b) => a.LinkOrder - b.LinkOrder)
                    .filter((link) => link.Enabled === true)
                    .map((link) => {
                    return (<li>
                        <NavLink 
                            key={link.LinkText + "link" + link.LinkUrl} 
                            LinkText={link.LinkText} 
                            LinkUrl={link.LinkUrl} 
                            NewWindow={link.NewWindow} 
                            IconUrl={link.IconUrl}
                            Bold={link.Bold}
                        />
                    </li>)
                })}
            </ul>
        </div>
    )
}
            
export default NavGroup